import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Subject, takeUntil } from 'rxjs';
import { DynamicsFieldsService } from 'src/app/shared/services';
import { InformationCollectorByPaymentComponent } from '../../information-collector-by-payment/collector/information-collector-by-payment.component';
import { InformationCollectorByPaymentService } from '../../information-collector-by-payment/collector/services/information-collector-by-payment.service';

@Component({
    selector: 'app-auto-pay-customer-reference',
    standalone: true,
    imports: [
        InformationCollectorByPaymentComponent,
        MatIconModule,
        MatDialogModule,
        MatButtonModule,
        MatProgressSpinnerModule,
    ],
    templateUrl: './auto-pay-customer-reference.component.html',
    styleUrl: './auto-pay-customer-reference.component.scss',
})
export class AutoPayCustomerReferenceComponent implements OnInit, OnDestroy {
    private unsubscribe$: Subject<void>;
    public isLoading = false;

    constructor(
        private informationCollectorByPaymentService: InformationCollectorByPaymentService,
        private dynamicFieldsService: DynamicsFieldsService
    ) {
        this.unsubscribe$ = new Subject<void>();
    }

    ngOnInit(): void {
        this.getCollectorForms();
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    getCollectorForms(): void {
        this.isLoading = true;
        this.informationCollectorByPaymentService
            .getCollectorForms$()
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe({
                next: (form: (FormGroup | null)[]) => {
                    this.isLoading = false;
                    this.dynamicFieldsService.setCollectorForms(form);
                },
                error: () => {
                    this.isLoading = false;
                },
            });
    }
}
